import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ZeditHomePage from "./pages/ZeditHomePage";
import LandingPage from "./pages/LandingPage";
import ClipsPage from "./pages/ClipsPage";
import TrueKolPage from "./pages/TrueKolPage";
import LayerSeekTermsPage from "./pages/LayerSeekTermsPage";
import LayerSeekRefundPolicyPage from "./pages/LayerSeekRefundPolicyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ZeditHomePage />} />
          <Route path="/layerseek" element={<LandingPage />} />
          <Route path="/layerseek/terms" element={<LayerSeekTermsPage />} />
          <Route path="/layerseek/refunds" element={<LayerSeekRefundPolicyPage />} />
          <Route path="/clips" element={<ClipsPage />} />
          <Route path="/truekol" element={<TrueKolPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
